export const formatTime = (sec: number): string => {
  const clamped = Math.max(0, sec);
  const totalSeconds = Math.floor(clamped);

  const h = Math.floor(totalSeconds / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;

  const hh = String(h).padStart(2, '0');
  const mm = String(m).padStart(2, '0');
  const ss = String(s).padStart(2, '0');

  if (h > 0) {
    return `${hh}:${mm}:${ss}`;
  }

  return `${mm}:${ss}`;
};
